import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const SvgIcon = (props: SvgIconT.Props) => {
  const { containerProps = {}, size, color, className = '', style = {}, innerRef, ...rest } = props;
  const fill = !color && !props.fill ? '#000' : props.fill;
  const width = !size && !props.width ? 24 : props.width;
  const height = !size && !props.height ? 24 : props.height;
  const { cssClassName } = convertPropToCssClassName('icon', className, {
    size,
    color,
  });
  return (
    <span
      ref={innerRef}
      className={cssClassName}
      {...rest}
      {...containerProps}
      style={{
        width,
        height,
        ...style,
      }}
    >
      <svg
        width={width && String(width)}
        height={height && String(height)}
        style={{
          width,
          height,
        }}
        fill={fill}
        viewBox="0 0 24 24"
      >
        <path
          d="M12.335625 0l3.7125 7.951875L24 11.664375V0H12.335625zM0 0v11.664375l7.951875-3.7125L11.664375 0H0zm16.048125 16.048125L12.335625 24H24V12.335625l-7.951875 3.7125zM0 24h11.664375l-3.7125-7.951875L0 12.335625V24z"
          fill="#000"
          fillRule="evenodd"
        />
      </svg>
    </span>
  );
};

export default SvgIcon;
